var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-wrapper',[_c('com-transitions'),_c('com-cta',{staticClass:"cta"}),_c('app-wrapper',_vm._l((_vm.page.sections),function(section,index){return _c('com-section',{key:index,attrs:{"index":index,"item":section}})}),1),_c('com-recent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }